import { useState } from 'react';
import { Box } from '@mui/material';
import { IStyles, Loader, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { CAEndedHwLeftPanel } from './components/CAEndedHwLeftPanel';
import { CAEndedHwRightPanel } from './components/CAEndedHwRightPanel';
import { AssessmentPageType } from '../ClickerAssessmentManage';

const styles: IStyles = {
  root: {
    width: '100vw',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: { xs: 'unset', md: 'space-between' },
    gap: { xs: pxToRem(15), md: pxTovW(30), lg: pxTovW(30) },
    paddingY: { xs: pxToRem(20), md: pxTovW(15), lg: pxTovW(15) },
    paddingX: { xs: pxToRem(17), md: pxTovW(20), lg: pxTovW(240) },
    paddingTop: { xs: pxToRem(20), md: pxTovW(40) },
    boxSizing: 'border-box',
    overflowX: 'hidden',
  },

  leftPanel: {
    width: { xs: '100%', md: pxTovW(800), lg: pxTovW(602) },
    boxSizing: 'border-box',
  },

  rightPanel: {
    width: { xs: '100%', md: pxTovW(1000), lg: pxTovW(786) },
    boxSizing: 'border-box',
  },
};

interface IProps {
  pageType: AssessmentPageType;
}
export const ClickerAssessmentEndedHw = (props: IProps) => {
  const { pageType } = props;

  const [isLoading, setIsLoading] = useState<'loading' | 'error' | 'success'>(
    'success'
  );

  // API CALLS

  if (isLoading === 'loading') return <Loader />;
  return (
    <Box sx={styles.root}>
      <Box sx={styles.leftPanel}>
        <CAEndedHwLeftPanel />
      </Box>

      <Box sx={styles.rightPanel}>
        <CAEndedHwRightPanel pageType={pageType} />
      </Box>
    </Box>
  );
};
